import { Link } from "../utils";

export interface Region {
	id: number
	name: string
}

export interface RegionResponse {
	data: RegionItem[];
	first_page_url: string;
	last_page: number;
	last_page_url: string;
	links: Link[];
	next_page_url: null;
	path: string;
	per_page: number;
	prev_page_url: null;
	to: number;
	total: number;
}

export interface RegionItem {
	id: number;
	region: string;
}

export interface DeleteRegionResponse {
	delete: boolean
	message: string
}
